import React from "react";
import { useParams } from "react-router-dom";
import { postData } from "../Commonfunction/CommonFunction";
import { toast } from "react-toastify";
import "../../assets/style/HistoryData.css";

export default function HistoryData(props) {
  const { id } = useParams();
  const {
    historyMainData,
    onClose,
    historyMainData2,
    addTax,
    height = "77vh",
  } = props;
  console.log("test===>", historyMainData2);
  const formatString = (str) => str.replace(/_/g, " ");

  if (
    !historyMainData ||
    typeof historyMainData !== "object" ||
    Object.keys(historyMainData).length === 0
  ) {
    return <p>No data available</p>;
  }
  const uploadTaxPanelSubmit = async (reason) => {
    // console.log("reason", reason)
    try {
      const request_url = `/api/update-customer-file/${id}`;
      const postDataResult = await postData(request_url, reason);
      toast.success(postDataResult.message);
      onClose();
    } catch (error) {
      // toast.error(error.response.data.message);
    }
  };

  const color = ["Q1 TOTAL", "Q2 TOTAL", "Q3 TOTAL", "Q4 TOTAL"];

  const categories2 = Object.keys(historyMainData2).reduce((acc, month) => {
    Object.keys(historyMainData2[month]).forEach((category) => {
      if (!acc.includes(category)) acc.push(category);
    });
    return acc;
  }, []);

  const rows2 = [];
  Object.keys(historyMainData2)?.forEach((month) => {
    Object.keys(historyMainData2?.[month])?.forEach((category) => {
      historyMainData2?.[month]?.[category]?.forEach((item) => {
        const taxHead = Object?.keys(item)[0];
        const existingRow = rows2?.find((row) => row.taxHead === taxHead);
        if (existingRow) {
          existingRow[`${month}_${category}`] = item[taxHead];
        } else {
          const newRow = { taxHead, [`${month}_${category}`]: item[taxHead] };
          rows2.push(newRow);
        }
      });
    });
  });
  const taxTypeData = [
    { label: "Gross Non fule", value: "#7593CE" },
    { label: "High", value: "#BAD9F8" },
    { label: "Low", value: "#F7FBFC" },
    { label: "Gas", value: "#FFE5E4" },
    { label: "Diesel", value: "#F8CACA" },
    { label: "Non Taxable", value: "#7593CE" },
    { label: "Other", value: "#BAD9F8" },
    { label: "GA Tax", value: "#F7FBFC" },
    { label: "Hotel Occupancy", value: "#FFE5E4" },
    { label: "Room Tax", value: "#F8CACA" },
    { label: "Adjustment", value: "#7593CE" },
    { label: "Custom", value: "#7593CE" },
    { label: "Non Food", value: "#BAD9F8" },
    { label: "Food Sales", value: "#F7FBFC" },
    { label: "CBD Sales", value: "#FFE5E4" },
    { label: "Non Taxable Sales", value: "#F8CACA" },
    { label: "Lotto & Non Sales", value: "#7593CE" },
    { label: "Other Misc Info", value: "#BAD9F8" },
    { label: "Calculation Total", value: "#F7FBFC" },
    { label: "Par B S U Distribution", value: "#FFE5E4" },
    { label: "S & U Return", value: "#F8CACA" },
    { label: "Vendor Compensation", value: "#7593CE" },
  ];
  return (
    <React.Fragment>
      <div>
        <div className="grid-row grid-gap">
          <div className="grid-col-12">
            <div className="overflow-auto">
              <table
                id="tax-head-table"
                className="usa-table modern-tax-table full-width-table"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>TAX HEAD</th>
                    {Object.keys(historyMainData2).map((month, i) => (
                      <th
                        key={i}
                        style={{
                          background: color?.includes(month)
                            ? "#e8f0fe"
                            : month === "FINAL TOTAL"
                            ? "#ccdfd6"
                            : "",
                          fontWeight: "600",
                        }}
                      >
                        {month}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {categories2.map((category, catIndex) => {
                    let categoryRows = rows2.filter((row) =>
                      Object.keys(row).some((key) => key.includes(category))
                    );

                    const totalRowIndex = categoryRows.findIndex(
                      (row) => row.taxHead === "Total"
                    );
                    if (totalRowIndex !== -1) {
                      const [totalRow] = categoryRows.splice(totalRowIndex, 1);
                      categoryRows.push(totalRow);
                    }

                    const rowSpan = categoryRows.length;

                    return (
                      <React.Fragment key={catIndex}>
                        {categoryRows.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {rowIndex === 0 && (
                              <td
                                rowSpan={rowSpan}
                                className="category-cell"
                                style={{
                                  backgroundColor: (() => {
                                    const label = category.replace(
                                      /[_-]/g,
                                      " "
                                    );
                                    const match = taxTypeData.find(
                                      (item) => item.label === label
                                    );
                                    return match ? match.value : "#f8f9fa";
                                  })(),
                                }}
                              >
                                {category.replace(/[_-]/g, " ")}
                              </td>
                            )}
                            <td
                              className={
                                row.taxHead === "Total" ? "font-bold" : ""
                              }
                            >
                              {formatString(row.taxHead)}
                            </td>
                            {Object.keys(historyMainData2).map((month, i) => (
                              <td
                                key={i}
                                style={{
                                  background: color?.includes(month)
                                    ? "#e8f0fe"
                                    : month === "FINAL TOTAL"
                                    ? "#ccdfd6"
                                    : "",
                                }}
                              >
                                <div className="cell-content">
                                  <span className="currency">$</span>
                                  <span
                                    className={
                                      formatString(row.taxHead) === "Total"
                                        ? "font-bold"
                                        : ""
                                    }
                                  >
                                    {parseFloat(
                                      row[`${month}_${category}`]
                                    ).toFixed(2)}
                                  </span>
                                </div>
                              </td>
                            ))}
                          </tr>
                        ))}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {addTax && (
              <div
                className="display-flex flex-justify-end padding-top-1 padding-right-2"
                style={{ gap: "10px" }}
              >
                <button
                  type="button"
                  className="usa-button usa-button--primary"
                  onClick={() => {
                    const date = new Date();
                    date.setMonth(date.getMonth() - 1);
                    const previousMonthName = date.toLocaleString("en-US", {
                      month: "long",
                    });

                    const finalData = {
                      month: previousMonthName,
                      uploaded_to_portal: 1,
                    };

                    uploadTaxPanelSubmit(finalData);
                  }}
                >
                  Upload To Tax Portal
                </button>
                <button
                  type="button"
                  className="usa-button bg-secondary text-white"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
